export const BUILDER_API_KEY = String(process.env.NEXT_PUBLIC_BUILDER_API_KEY)
